var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmoker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 39,
    rx: 5,
    fill: "#F4F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 22.7473H12C10.8954 22.7473 10 23.6427 10 24.7473C10 25.8519 10.8954 26.7473 12 26.7473H26V22.7473Z",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9589 14.6368V14.3027C20.9589 13.1705 20.0411 12.2527 18.9089 12.2527C18.4069 12.2527 18 12.6596 18 13.1616V16.0344C18 17.3906 19.0994 18.49 20.4556 18.49H23.5456C23.8117 18.49 24.0274 18.7057 24.0274 18.9718C24.0274 19.6792 24.6009 20.2527 25.3083 20.2527H25.5616C25.9123 19.6018 26 18.5352 26 18.0832C26 15.8052 24.2466 14.9646 23.3699 14.829H21.1511C21.0449 14.829 20.9589 14.7429 20.9589 14.6368Z",
    stroke: "#065EEA",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoker);
export default __webpack_public_path__ + "static/media/Smoker.e786f9a179f151976226f2d4cfb4be5f.svg";
export { ForwardRef as ReactComponent };